var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.type === "transaction" ? _c('transaction-result', {
    staticClass: "search_result",
    attrs: {
      "item": _vm.item.data
    }
  }) : _vm.type === "address" ? _c('address-result', {
    staticClass: "search_result",
    attrs: {
      "item": _vm.item.data
    }
  }) : _vm.type === "asset" ? _c('asset-result', {
    staticClass: "search_result",
    attrs: {
      "item": _vm.item.data
    }
  }) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }